<template>
  <div class="serviceHealth">
    <div class="module-header">健康度配置</div>

    <a-tabs
      v-model="activeKey"
      style="margin: 16px 56px 0 56px"
    >
      <a-tab-pane
        v-for="item in tabsData"
        :key="item.id"
      >
        <template #tab>
          <a-icon type="setting" style="font-size: 16px"/>
          {{ item.name }}
        </template>
        <form-setting
          :detail="item"
        ></form-setting>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { getServiceHealthDimensionList } from '@/api/service-health.js'
import FormSetting from './modules/FormSetting.vue'

export default {
  name: 'ServiceHealth',
  components: {
    FormSetting
  },
  data () {
    return {
      tabsData: [],
      activeKey: ''
    }
  },
  created () {
    getServiceHealthDimensionList().then(res => {
      this.tabsData = res.data
      if (this.tabsData.length) this.activeKey = this.tabsData[0].id
    })
  }
}
</script>

<style lang="less" scoped>
.serviceHealth {
  position: relative;
  border-radius: 8px;
  background: #fff;
  min-height: calc(100vh - 158px);
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
  padding: 18px;

  .main-container {
    padding: 4px 60px;
  }
}
</style>
